export enum ActionTypeEnum {
    ALLOCATION_PARTY_COMMENT = "ALLOCATION_PARTY_COMMENT",
    CHEFIT_DENIED = "CHEFIT_DENIED",
    COULD_NOT_FIND_COOK = "COULD_NOT_FIND_COOK",
    CREATE_COOK_LEAVE = "CREATE_COOK_LEAVE",
    CX_FEEDBACK = "CX_FEEDBACK",
    CX_NOT_AVAILABLE_FUTURE_LEAVE = "CX_NOT_AVAILABLE_FUTURE_LEAVE",
    CX_NOT_AVAILABLE_PAST_LEAVE = "CX_NOT_AVAILABLE_PAST_LEAVE",
    DISCOUNT_COUPON_ORDER_REFUND = "DISCOUNT_COUPON_ORDER_REFUND",
    HC_NOT_AVAILABLE_FUTURE_LEAVE = "HC_NOT_AVAILABLE_FUTURE_LEAVE",
    HC_NOT_AVAILABLE_PAST_LEAVE = "HC_NOT_AVAILABLE_PAST_LEAVE",
    NOT_CONVERTED_COOK_ISSUES = "NOT_CONVERTED_COOK_ISSUES",
    NOT_CONVERTED_CX_ISSUES = "NOT_CONVERTED_CX_ISSUES",
    OCCASION = "OCCASION",
    PARTY_DENIED = "PARTY_DENIED",
    PARTY_LEAD_TAG_LOST = "PARTY_LEAD_TAG_LOST",
    PENALTY_REJECTION = "PENALTY_REJECTION",
    PENALTY_REVOKE = "PENALTY_REVOKE",
    POST_ALLOCATION = "POST_ALLOCATION",
    POST_ALLOCATION_CANCELLED = "POST_ALLOCATION_CANCELLED",
    POST_ALLOCATION_CANCELLED_INSTANT_CHEFIT = "POST_ALLOCATION_CANCELLED_INSTANT_CHEFIT",
    POST_ALLOCATION_RESCHEDULED = "POST_ALLOCATION_RESCHEDULED",
    PRE_ALLOCATION_CANCELLED = "PRE_ALLOCATION_CANCELLED",
    PRE_ALLOCATION_CANCELLED_INSTANT_CHEFIT = "PRE_ALLOCATION_CANCELLED_INSTANT_CHEFIT",
    PRE_ALLOCATION_RESCHEDULED = "PRE_ALLOCATION_RESCHEDULED",
    PR_CLOSURE = "PR_CLOSURE",
    PR_CREATION = "PR_CREATION",
    PR_CREATION_WITHOUT_COOK_SUBSCRIPTION = "PR_CREATION_WITHOUT_COOK_SUBSCRIPTION",
    RATING = "RATING",
    RATING_1 = "RATING_1",
    RATING_2 = "RATING_2",
    RATING_3 = "RATING_3",
    RATING_4 = "RATING_4",
    RATING_5 = "RATING_5",
    REASON_FOR_PR_TRIAL = "REASON_FOR_PR_TRIAL",
    REJECT_5_STAR_INCEVTIVE = "REJECT_5_STAR_INCEVTIVE",
    REJECT_CONVEYANCE = "REJECT_CONVEYANCE",
    RESCHEDULED_POST_ALLOCATION = "RESCHEDULED_POST_ALLOCATION",
    RESCHEDULED_PRE_ALLOCATION = "RESCHEDULED_PRE_ALLOCATION",
    SOS_COMMENTS = "SOS_COMMENTS",
    SUBSCRIPTION_CLOSURE = "SUBSCRIPTION_CLOSURE",
}
